import { Box, styled } from '@mui/material';

export const MappingSidebarContent = styled(Box)(() => ({
  height: '100%',
  maxHeight: '100%',
  marginLeft: '30px',
  paddingRight: '56px',
  overflow: 'scroll',
}));
